import React, { useState } from "react"
import styled from "styled-components"
import { signInWithPopup } from "firebase/auth"
import { auth, provider } from "../lib/firebase"
import Option from "./Question"
import ButtonGmail from "./ButtonGmail"
import { LEGAL_PATHS } from "../constants/legal"
import { ACTIVE_HEADER_VARIANT, HEADER_VARIANTS } from "../config/headerTheme"

const EvaluationHost = ({ onSelection, onNoVoting, onThanksPage, customQuestions }) => {
    const [options, setOptions] = useState({
        question1: 0,
        question2: 0,
        question3: 0,
        question4: 0,
        question5: 0,
        clientEmail: null,
        authForGoogle: false,
        authForFacebook: false,
        clientName: null,
    })
    const [isSubmitting, setIsSubmitting] = useState(false)

    const hasAtLeastOneAnswer = () => {
        return options.question1 > 0 || 
               options.question2 > 0 || 
               options.question3 > 0 || 
               options.question4 > 0 || 
               options.question5 > 0 ||
               Object.keys(options).some(key => 
                   key.startsWith('question') && 
                   key !== 'question1' && 
                   key !== 'question2' && 
                   key !== 'question3' && 
                   key !== 'question4' && 
                   key !== 'question5' && 
                   options[key] > 0
               );
    }

    const handleGoogle = async () => {
        if (isSubmitting) return;
        
        try {
            setIsSubmitting(true);
            const response = await signInWithPopup(auth, provider)
            const name = response?.user?.displayName
            const email = response?.user?.email
            const o = { ...options, clientName: name, clientEmail: email, authForGoogle: true }
            setOptions(o)
            
            if (hasAtLeastOneAnswer()) {
                await onSelection(o);
            }
            onThanksPage(true)
            onNoVoting()
        } catch (error) {
            console.error("Error al iniciar sesión con Google:", error);
            alert("Error al iniciar sesión con Google. Por favor, intenta nuevamente.");
        } finally {
            setIsSubmitting(false);
        }
    }

    const onSelect = (id, value) => {
        const o = { ...options, [id]: value }
        setOptions(o)
        // No llamar onSelection aquí - solo actualizar estado
        // Se enviará cuando el usuario haga submit
    }

    const noInterest = async () => {
        if (isSubmitting) return;
        
        try {
            setIsSubmitting(true);
            // Enviar evaluación incluso si no hay respuestas (usuario no está interesado)
            await onSelection(options);
            onNoVoting();
        } catch (error) {
            console.error("Error al enviar evaluación:", error);
            alert("Error al procesar tu respuesta. Por favor, intenta nuevamente.");
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <>
            <Evaluations>
                <Heading>Evalúa este almacén.</Heading>

                <Option id="question1" label="¿Cómo evaluarías la limpieza y el orden del almacén?" onSelect={onSelect} />
                <Option id="question2" label="¿Cómo evaluarías la amabilidad en la atención?" onSelect={onSelect} />
                <Option id="question3" label="¿Cómo evaluarías la rapidez para atenderte y entregar tu compra?" onSelect={onSelect} />
                <Option id="question4" label="¿Cómo evaluarías la ayuda para encontrar o elegir productos?" onSelect={onSelect} />
                <Option id="question5" label="¿Cómo evaluarías la solución de errores o imprevistos?" onSelect={onSelect} />
                
                {customQuestions && customQuestions.length > 0 && customQuestions?.map((e, index) => {
                    // TODO: Validar en backend que estas preguntas personalizadas no usen lenguaje de restaurante.
                    return (<Option key={e.id || `custom-${index}`} id={e.id} label={e.label} onSelect={onSelect} />)
                })}

                <ButtonsSocial>
	                    <Texts>
	                        <p>Para finalizar tu evaluación, regístrate.</p>
	                        <p>
	                            Al confirmar estarás de acuerdo con los{" "}
	                            <TermsLink href={LEGAL_PATHS.hostTerms} target="_blank" rel="noreferrer">
	                                Términos
	                            </TermsLink>{" "}
	                            y la{" "}
	                            <TermsLink href={LEGAL_PATHS.privacy} target="_blank" rel="noreferrer">
	                                Política de Privacidad
	                            </TermsLink>.
	                        </p>
	                    </Texts>

                    <ButtonGmail onClick={handleGoogle} disabled={isSubmitting} />

                    <NoInterest type="button" onClick={noInterest} disabled={isSubmitting}>
                        {isSubmitting ? "Enviando..." : "No me interesa"}
                    </NoInterest>
                </ButtonsSocial>
            </Evaluations>
        </>
    )
}

export default EvaluationHost

/* ========= styled-components ========= */

const Evaluations = styled.div`
  padding: 20px 15px;
`

const Heading = styled.h6`
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 12px 0;
  color: #111827;
`


const ButtonsSocial = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const Texts = styled.div`
  padding: 12px 0 4px 0;

  p {
    margin: 0;
    text-align: left;
    font-size: 12px;
    color: #374151;
  }
`

const TermsLink = styled.a`
  color: ${() => HEADER_VARIANTS[ACTIVE_HEADER_VARIANT].accent};
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`

const NoInterest = styled.button`
  height: 52px;
  width: 100%;
  background: transparent;
  border: none;
  color: ${() => HEADER_VARIANTS[ACTIVE_HEADER_VARIANT].accent};
  font-weight: 700;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover:not(:disabled) {
    text-decoration: underline;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`
